import { useState, useEffect } from 'react';
import { Calendar, Shield, UserCheck, Award, Star, Heart, Target, Zap } from 'lucide-react';

import { whyOwaza } from '../data/mock';
import { isPrerendering } from '../services/api';

import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  Calendar,
  Shield,
  UserCheck,
  Award,
  Star,
  Heart,
  Target,
  Zap
};

const WhyOwazaSection = () => {
  const [cards, setCards] = useState(whyOwaza);

  useEffect(() => {
    // Skip API calls during pre-rendering (react-snap)
    if (isPrerendering()) return;

    const fetchCards = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/why-owaza`);
        if (response.ok) {
          const data = await response.json();
          if (data && data.length > 0) {
            setCards(data);
          }
        }
      } catch (error) {
        console.error('Failed to fetch why owaza cards');
      }
    };
    fetchCards();
  }, []);

  return (
    <section className="py-20 bg-gradient-to-br from-gray-100 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-gray-900 mb-4">
            Why Choose Owaza?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're not just another martial arts studio. Our unique approach ensures
            focused, safe, and effective training for every student.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {cards.map((item, index) => {
            const IconComponent = iconMap[item.icon] || Shield;

            return (
              <Card key={item.id || index} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-md text-center">
                <CardHeader className="pb-4">
                  <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center group-hover:bg-red-600 transition-colors duration-300 mb-4">
                    <IconComponent className="h-8 w-8 text-red-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors">
                    {item.title}
                  </CardTitle>
                </CardHeader>

                <CardContent>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyOwazaSection;
